const GALLERY_FOLDERS = ["/mehndiImages", "/makeupImages"];
const CONCURRENCY = 2;
const PRELOAD_LIMIT = 6;

let hasStarted = false;

const preloadImage = (src) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
  });

const runWithConcurrency = async (items, worker, limit) => {
  let index = 0;

  const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (index < items.length) {
      const current = index;
      index += 1;
      await worker(items[current]);
    }
  });

  await Promise.all(runners);
};

const startWhenIdle = (callback) => {
  if (typeof window === "undefined") {
    return;
  }

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(callback, { timeout: 1200 });
  } else {
    setTimeout(callback, 50);
  }
};

export const preloadGalleryImages = () => {
  if (hasStarted || typeof window === "undefined") {
    return;
  }

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection?.saveData) {
    return;
  }
  if (typeof connection?.effectiveType === "string" && /2g/.test(connection.effectiveType)) {
    return;
  }

  hasStarted = true;

  startWhenIdle(async () => {
    for (const folder of GALLERY_FOLDERS) {
      try {
        const response = await fetch(`${folder}/list.json`);
        if (!response.ok) {
          continue;
        }

        const files = await response.json();
        if (!Array.isArray(files) || files.length === 0) {
          continue;
        }

        const urls = files.slice(0, PRELOAD_LIMIT).map((file) => `${folder}/${file}`);
        await runWithConcurrency(urls, preloadImage, CONCURRENCY);
      } catch (error) {
        console.error(`Failed to preload ${folder}.`, error);
      }
    }
  });
};
